var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNameIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27778 4.22222C5.27778 3.10242 5.72262 2.02848 6.51444 1.23666C7.30626 0.44484 8.3802 0 9.5 0C10.6198 0 11.6937 0.44484 12.4856 1.23666C13.2774 2.02848 13.7222 3.10242 13.7222 4.22222C13.7222 5.34203 13.2774 6.41596 12.4856 7.20778C11.6937 7.9996 10.6198 8.44444 9.5 8.44444C8.3802 8.44444 7.30626 7.9996 6.51444 7.20778C5.72262 6.41596 5.27778 5.34203 5.27778 4.22222ZM5.27778 10.5556C3.87802 10.5556 2.5356 11.1116 1.54583 12.1014C0.55605 13.0912 0 14.4336 0 15.8333C0 16.6732 0.33363 17.4786 0.927495 18.0725C1.52136 18.6664 2.32681 19 3.16667 19H15.8333C16.6732 19 17.4786 18.6664 18.0725 18.0725C18.6664 17.4786 19 16.6732 19 15.8333C19 14.4336 18.444 13.0912 17.4542 12.1014C16.4644 11.1116 15.122 10.5556 13.7222 10.5556H5.27778Z",
    fill: "#2E8056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/nameIcon.4e5895c35872033d2a21d98f0a5186e1.svg";
export { ForwardRef as ReactComponent };